<template>
  <div
    id="404"
    class="w-full px-4 mx-auto max-w-7xl flex flex-col items-center justify-center text-center h-100 sm:px-8 md:px-8 md:mb-8"
  >
    <img
      class="-mb-4"
      src="@/assets/images/no-records.svg"
      alt="404 not found"
    />
    <h3 class="mb-sm text-lg font-semibold md:text-xl">
      Oops! We can't seem to find the page you're looking for.
    </h3>
    <p class="max-w-md text-2sm mb-sm text-gray-600">Error code: 404</p>
    <p class="max-w-md text-2sm text-gray-600">
      Here are some helpful links instead:
    </p>
    <p class="max-w-md text-2sm">
      <router-link
        class="student-link api-link"
        v-if="isLoggedIn"
        :to="'/my-students'"
      >
        My Students
      </router-link>
    </p>
    <p class="max-w-md text-2sm">
      <router-link
        class="student-link api-link"
        v-if="isLoggedIn"
        :to="'/notification-settings'"
      >
        Notifications
      </router-link>
    </p>

    <p class="max-w-md text-2sm">
      <router-link
        class="student-link api-link"
        v-if="!isLoggedIn"
        :to="'/sign-in'"
      >
        Sign In
      </router-link>
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "not-found",
  computed: {
    ...mapGetters(["isLoggedIn"]),
    url() {
      return window.location.origin;
    }
  }
};
</script>

<style lang="postcss" scoped>
.mb-sm {
  margin-bottom: 10px;
}
</style>
